<template>
  <v-card
    class="ma-0 pa-0 matchdet"
    width="100%"
  >
    <v-card-title class="greyee">
      <span class="font-weight-medium">{{ '$l.case.age' | translate }}</span>
    </v-card-title>

    <v-card-text
      v-for="(item, index) in match.detail.age"
      :key="index"
    >
      <div v-if="checkIfEmpty(item.age)">
        {{ $i18n.t('$l.case.age') + ': ' + item.age }}
      </div>

      <div v-if="checkIfEmpty(item.asofdate)">
        {{ $i18n.t('$l.case.asofdate') + ': ' + item.asofdate }}
      </div>

      <div v-if="checkIfEmpty(item.deceased)">
        {{ $i18n.t('$l.case.deceased') + ': ' + item.deceased }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Age',
  props: {
    match: {
      type: Object,
      required: true
    }
  },
  methods: {
    checkIfEmpty (data) {
      if (data && data.length > 0 && data !== 'null' && data !== 'unknown' && data !== undefined) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
